import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "80aaa6a6-1643-4d13-8e62-f75d2400d8b8",
    options: { imageUrl: `${config.ASSETS_URL}/04/26/task/task-1-item-1.svg` },
  },
  {
    id: "be6b5dca-f31c-4039-ac79-c4b335979f05",
    options: { imageUrl: `${config.ASSETS_URL}/04/26/task/task-1-item-2.svg` },
  },
  {
    id: "82bda8df-13e4-4afb-a144-5a2a1f1900b6",
    options: { imageUrl: `${config.ASSETS_URL}/04/26/task/task-1-item-3.svg` },
  },
  {
    id: "7d293a12-acbe-4dee-9d1f-878d66608901",
    options: { imageUrl: `${config.ASSETS_URL}/04/26/task/task-1-item-4.svg` },
  },
];

const groups = [
  { id: "41a01a11-4034-411c-96ea-c7556ab8fa3d", content: "Theoretical constant Bℓ", options: {} },
  { id: "755ac100-6cc3-452f-a7b7-959131d945a2", content: "Equal length", options: {} },
  { id: "0b41b874-f37c-4e17-99db-5f8dfe123852", content: "Underhung", options: {} },
  { id: "8c0c9101-b80e-4411-b69c-d07a99bcb6cf", content: "Overhung", options: {} },
];

export const task: Task = {
  id: "9629d294-10a3-4120-8980-3947411b1294",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    shuffle: true,
    orientation: "vertical",
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "41a01a11-4034-411c-96ea-c7556ab8fa3d", itemsId: ["80aaa6a6-1643-4d13-8e62-f75d2400d8b8"] },
    { groupId: "755ac100-6cc3-452f-a7b7-959131d945a2", itemsId: ["7d293a12-acbe-4dee-9d1f-878d66608901"] },
    { groupId: "0b41b874-f37c-4e17-99db-5f8dfe123852", itemsId: ["be6b5dca-f31c-4039-ac79-c4b335979f05"] },
    { groupId: "8c0c9101-b80e-4411-b69c-d07a99bcb6cf", itemsId: ["82bda8df-13e4-4afb-a144-5a2a1f1900b6"] },
  ],
};
